// Renders a preflight report (see compartment_report_calc_service's
// preflight.py::run_preflight() for the exact shape - report.summary,
// report.inputs, report.checks[].{matrix|issues}). Each check's matrix/
// issues rendering is shared with DataQualityControlPanel/
// CashflowReconciliationPanel via CheckResultCard.js - only the outer
// Accordion-of-many-checks layout is specific to this component.

import React from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { StatusTag, MatrixTable, IssuesTable, checkQualifierText } from './CheckResultCard';

const statusTag = (status) => <StatusTag status={status} />;

const CheckHeader = ({ check }) => (
  <span className="cr-check-header">
    {statusTag(check.status)}
    <span>{check.name}</span>
    <span className="cr-check-qualifier">{checkQualifierText(check)}</span>
  </span>
);

const PreflightPanel = ({ report, onJumpToRow }) => {
  if (!report) return <p className="cr-muted-text">No preflight report yet.</p>;

  const { summary, inputs, checks, added_columns } = report;

  return (
    <div>
      <div className="cr-summary-line">
        {statusTag(report.status)}
        <span>
          {summary.passed}/{summary.total_checks} passed - {summary.errors} error(s) - {summary.warnings} warning(s)
        </span>
      </div>

      <div className="cr-meta-block">
        <div>
          Loan Tape: {inputs.loantape.filename} ({inputs.loantape.rows} rows, {inputs.loantape.columns.length} columns)
        </div>
        {inputs.cashflows && (
          <div>
            CashFlows: {inputs.cashflows.filename} ({inputs.cashflows.rows} rows, {inputs.cashflows.columns.length} columns)
          </div>
        )}
        {added_columns && added_columns.length > 0 && (
          <div>
            Calculated columns added:{' '}
            {added_columns.map((c, i) => (
              <span key={c.name}>
                {i > 0 && ', '}
                <code title={c.formula}>{c.name}</code>
                {c.status !== 'ok' && ` (${c.status})`}
              </span>
            ))}
          </div>
        )}
      </div>

      <Accordion multiple>
        {checks.map((check) => (
          <AccordionTab key={check.check_id} header={<CheckHeader check={check} />}>
            {check.matrix ? (
              <MatrixTable matrix={check.matrix} />
            ) : (
              <p>{check.summary}</p>
            )}
            {check.issues_truncated && (
              <p className="cr-warning-text">
                Showing a truncated subset of issues per field - see the full export for the rest.
              </p>
            )}
            <IssuesTable issues={check.issues} onJumpToRow={onJumpToRow} />
          </AccordionTab>
        ))}
      </Accordion>
    </div>
  );
};

export default PreflightPanel;
